import React, { useEffect, useRef, useState } from "react";
import "./SideCardHorizntalTabComp.css";
import * as FeatherIcon from "react-feather";

function SideCardHorizntalTabComp({ tabConfig, setShowMoreModal,activeTab = 'tab1', setActiveTab }) {


  const tabRefs = useRef({});
  const tabContainerRef = useRef(null); // Reference for tab container
  const ActiveComponent = tabConfig?.find(
    (tab) => tab?.key === activeTab
  )?.Component;
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [showArrows, setShowArrows] = useState(false); // New state to control arrow visibility

  const updateScrollButtons = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      const canScrollLeftValue = tabContainer.scrollLeft > 0;
      const canScrollRightValue =
        tabContainer.scrollLeft + tabContainer.clientWidth <
        tabContainer.scrollWidth;

      setCanScrollLeft(canScrollLeftValue);
      setCanScrollRight(canScrollRightValue);

      // Show arrows only if the content is scrollable
      setShowArrows(tabContainer.scrollWidth > tabContainer.clientWidth);
    }
  };

  const scrollLeft = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      tabContainer.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      tabContainer.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  useEffect(() => {
    updateScrollButtons(); // Initially check if scrolling is needed
    const tabContainer = tabContainerRef.current;

    if (tabContainer) {
      tabContainer.addEventListener("scroll", updateScrollButtons);
      window.addEventListener("resize", updateScrollButtons); // Recheck on window resize
    }

    return () => {
      if (tabContainer) {
        tabContainer.removeEventListener("scroll", updateScrollButtons);
      }
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, []);

  useEffect(() => {
    if (tabRefs.current[activeTab]) {
      tabRefs.current[activeTab].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeTab]);

  return (
    <div className="tab-wrapper">

        <>
          <div className="horizontal-tabs">
            {showArrows && (
              <>
                <button
                  className="scroll-btn left-arrow"
                  onClick={scrollLeft}
                  disabled={!canScrollLeft}
                >
                  <FeatherIcon.ArrowLeftCircle className="icons_table mr-1" />
                </button>
              </>
            )}

            <div className="d-flex custom_nav_tab" ref={tabContainerRef}>
              {tabConfig?.map(({ key, label, icon }) => (
                <button
                  key={key}
                  ref={(el) => (tabRefs.current[key] = el)} 
                  className={`tab-button ${activeTab === key ? "active" : ""}`}
                  onClick={() => setActiveTab(key)}
                >
                  {icon}
                  <span className="tab-label">{label}</span>
                </button>
              ))}
            </div>

            {showArrows && ( // Conditionally render arrows based on `showArrows` state
              <>
                <button
                  className="scroll-btn right-arrow"
                  onClick={scrollRight}
                  disabled={!canScrollRight}
                >
                  <FeatherIcon.ArrowRightCircle className="icons_table mr-1" />
                </button>
              </>
            )}
          </div>
          <div className="tab-content">
            {ActiveComponent && <ActiveComponent />}
          </div>
        </>
      
    </div>
  );
}

export default SideCardHorizntalTabComp;
